import { render, staticRenderFns } from "./applyRiskDialog.vue?vue&type=template&id=039f7708&scoped=true"
import script from "./applyRiskDialog.vue?vue&type=script&lang=js"
export * from "./applyRiskDialog.vue?vue&type=script&lang=js"
import style0 from "./applyRiskDialog.vue?vue&type=style&index=0&id=039f7708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f7708",
  null
  
)

export default component.exports